<template>
    <div>
        <v-container>
            <div class="text-h5 text-sm-h5 text-md-h4 text-lg-h4 ma-3 text-xl-h4 text-center">
                Categorías de incidencia
            </div>

            <v-form :disabled="loading">
                <v-row>
                    <v-col cols="12" sm="7" md="5" lg="5" xl="3">
                        <IncCatFind 
                            class="mb-n7" 
                            ref="incCatFind" 
                            v-model="filtros.IncCatParent" 
                            label="Tipo"
                            :showParentsOnly="true"
                            @change="loadData">
                        </IncCatFind>
                    </v-col>
                    <v-col cols="12" sm="7" md="5" lg="5" xl="3">
                      <v-text-field
                          class="mb-n7"
                          outlined
                          dense
                          text
                          v-model="filtros.IncCatNom"
                          label="Nombre"
                          @change="loadData">
                      </v-text-field>
                    </v-col>
                </v-row>
            </v-form>

            <v-btn
                color="primary"
                class="mt-5 mb-3"
                :disabled="!canCreate"
                @click="onClickNuevaCategoria">
                Nueva
            </v-btn>

            <v-data-table
                :headers="headers"
                :items="dataRows"
                :options.sync="options"
                :footer-props="{itemsPerPageOptions: [15, 30, 50, 100]}"
                :server-items-length="totalDataRows"
                :loading="loading"
                @click:row="onClickRowEditarCategoria"
                style="overflow: scroll"
                mobile-breakpoint="0"
                class="elevation-1"
                dense>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.Opt="{ item }">
                    <v-btn
                        class="my-1" small
                        style="width:30px; min-width:30px;"
                        :disabled="loading"
                        @click.stop="selectParent(item)">
                        <v-icon>mdi-arrow-down-right</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-container>
    </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import IncCatFind from "../components/IncCatFind.vue";
export default ({
    components: {
        IncCatFind
    },
    computed: {
        ...mapState(['empId', 'perId', 'urlRaiz']),
        canCreate: function () {
            if (this.filtros.IncCatParent == null) { return true; }
            const mantenimientoId = 1;
            return this.filtros.IncCatParent.IncCatId != mantenimientoId; // No es mantenimiento
        }
    },
    data () {
        return {
            loading: true,
            totalDataRows: 0,
            dataRows: [],
            options: {itemsPerPage: 15},
            headers: [
                { text: 'Código', width: 50, sortable: false, value: 'IncCatCod' },
                { text: 'Nombre', width:250, sortable: false, value: 'IncCatNom' },
                { text: 'Observaciones', width: 250, sortable: false, value: 'IncCatObs' },
                { text: '', width: 50, sortable: false, value: 'Opt', align: 'end' }
            ],
            dtOptionsLoaded: false,
            filtros: {
                IncCatNom: '',
                IncCatParent: null
            }
        }
    },
    watch: {
      options: {
        handler () {
          // Evitamos la llamada a la API en la primera carga de las options
          if(!this.dtOptionsLoaded) {
            this.dtOptionsLoaded = true;
            return;
          }
          this.loadData();
        },
        deep: true
      },
      // filtros: {
      //   handler () {
      //     this.loadData();
      //   },
      //   deep: true
      // },
      loading: {
        handler() {
          if (this.loading) {
            this.$refs.incCatFind.$refs.IncCatFindCtrl.isMenuActive = false;
          }
        },
        deep: true
      }
    },
    mounted() {
      this.loadData();
    },
    methods: {
      getDataFromApi() {
        this.loading = true;

        var NumRegsPag = this.options.itemsPerPage;
        var NumPag = this.options.page;

        return new Promise((resolve) => {
          const controllerParameters = {
            Action: 'GET_DATA_LIST_PAGINATED',
            NumRegsPag: NumRegsPag,
            NumPag: NumPag,
            IncCatNom: this.filtros.IncCatNom,
            IncCatIdParent: this.filtros.IncCatParent != null ? this.filtros.IncCatParent.IncCatId : null,
            ShowNoParentOnly: true,
            EmpId: this.empId
          };
          const AuthToken = localStorage.getItem('token');
          axios({ method: "POST", "url": this.urlRaiz + "/api/inccat", "data": JSON.stringify(controllerParameters), "headers": {"content-type": "application/json", "Authorization": AuthToken } })
          .then(result => {
            const items = result.data.EntsList;
            const total = result.data.EntsTotCount;

            setTimeout(() => {
                this.loading = false
                resolve({
                    items,
                    total
                })
            }, 1000)
          })
          .catch(error => {
            if(error != null) {
                this.loading = false;
                alert('Error al cargar las categorías.');
            }
          });
        })
      },
      loadData() {
        this.getDataFromApi()
        .then(data => {
          this.dataRows = data.items;
          this.totalDataRows = data.total;
        });
      },
      selectParent(item) {
        this.filtros.IncCatParent = {
          IncCatId: item.IncCatId,
          IncCatNom: item.IncCatNom
        };
        this.loadData();
      },
      setParentData(data) {
        this.$store.state.IncCatParentData = data;
      },
      onClickNuevaCategoria() {
        this.setParentData(this.filtros.IncCatParent);
        this.$router.push('/categoria-incidencia-nueva/');
      },
      onClickRowEditarCategoria(item) {
        this.setParentData(null);
        this.$router.push('/categoria-incidencia-editar/' + item.IncCatId);
      }
    }
})
</script>
